import { useEffect, useState } from "react";
import ApiService from "../services/ApiService";

type Flag = 'RoleManagement'
            | 'Reporting'
            | 'Users'
            | 'VendorId';

export const useFeatureFlags = () => {
  const [flagsLoading, setFlagsLoading] = useState(true);
  const [flags, setFlags] = useState<string[]>([]);
  const hasFlag = (flag: Flag) => {
    return Array.isArray(flags) && flags.includes(flag);
  }

  const normalizeFlags = (raw: unknown): string[] => {
    if (Array.isArray(raw)) {
      return raw.filter((item): item is string => typeof item === "string");
    }

    if (raw && typeof raw === "object" && Array.isArray((raw as { data?: unknown }).data)) {
      return ((raw as { data: unknown[] }).data).filter((item): item is string => typeof item === "string");
    }

    return [];
  };

  useEffect(() => {
    ApiService.getFeatureFlags()
      .then((featureFlags) => {
        setFlags(normalizeFlags(featureFlags));
      })
      .catch(() => {
        setFlags([]);
      })
      .finally(() => {
        setFlagsLoading(false);
      });
  }, []);

  return { flags, flagsLoading, hasFlag };
};
